import { render } from "./OSInformativoReportPage.vue?vue&type=template&id=422b8d46"
import script from "./OSInformativoReportPage.vue?vue&type=script&lang=js"
export * from "./OSInformativoReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__